/**
 * 🏠 TIER 1 BUILDINGS - Basic Gatherers
 * 
 * Available from game start. No tech required.
 * Base costs: 50-100 | Base production: 0.5-0.6/s
 * Target ROI: ~60 seconds
 */

export const TIER_01_BUILDINGS = {
  woodcutter: {
    id: 'woodcutter',
    name: "Woodcutter's Hut",
    icon: '⚒️',
    tier: 1,
    description: 'Chops wood from nearby forests',
    flavor: 'Every empire begins with a single swing of the axe.',
    baseCost: { wood: 50 },
    baseProduction: { wood: 0.5 },
    unlockCondition: null,
  },

  forager: {
    id: 'forager',
    name: 'Forager Hut',
    icon: '🍄',
    tier: 1,
    description: 'Gathers food from the wild',
    flavor: 'The forest provides for those who know where to look.',
    baseCost: { wood: 75 },
    baseProduction: { food: 0.4 },
    unlockCondition: null,
  },

  hunter: {
    id: 'hunter',
    name: 'Hunter Lodge',
    icon: '🏹',
    tier: 1,
    description: 'Hunts animals for food',
    flavor: 'Patient hunters eat well.',
    baseCost: { wood: 100 },
    baseProduction: { food: 0.6 },
    unlockCondition: null,
  },

  gathererCamp: {
    id: 'gathererCamp',
    name: 'Gatherer Camp',
    icon: '🏕️',
    tier: 1,
    description: 'Collects berries and kindling from the wilderness',
    flavor: 'A little of everything keeps the camp running.',
    baseCost: { wood: 80 },
    baseProduction: { wood: 0.25, food: 0.25 },
    unlockCondition: null,
  },

  stonePicker: {
    id: 'stonePicker',
    name: 'Stone Picker Hut',
    icon: '👐',
    tier: 1,
    description: 'Collects loose stones and edible roots from the fields',
    flavor: 'Bent backs build strong foundations.',
    baseCost: { wood: 90 },
    baseProduction: { stone: 0.3, food: 0.2 },
    unlockCondition: null,
  },

  homestead: {
    id: 'homestead',
    name: 'Homestead',
    icon: '🏡',
    tier: 1,
    description: 'A self-sufficient dwelling that produces a bit of everything',
    flavor: 'From humble beginnings, great civilizations rise.',
    baseCost: { wood: 100, stone: 25 },
    baseProduction: { wood: 0.2, stone: 0.15, food: 0.2 },
    unlockCondition: null,
  },

  skinTrader: {
    id: 'skinTrader',
    name: 'Skin Trader',
    icon: '🦊',
    tier: 1,
    description: 'Trades animal pelts and hides for coin',
    flavor: 'Fur and leather fetch a fair price in any village.',
    baseCost: { wood: 120, food: 30 },
    baseProduction: { gold: 0.2 },
    unlockCondition: null,
  },
};

export default TIER_01_BUILDINGS;